// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudiosByLanguage_container__rz1HC {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding-bottom: 2rem;
  background-color: #1a1a1a;
  color: #fff;
  min-height: 100vh;
  
}

/* Hero Section Styles - Netflix-like */
.AudiosByLanguage_heroSection__vgGYM {
  position: relative;
  margin-bottom: 0rem;
  height: 80vh;
  max-height: 700px;
  width: 100%;
}

.AudiosByLanguage_heroSwiper__Mblo\\+ {
  width: 100%;
  height: 100%;
}

.AudiosByLanguage_heroSlide__W5hxe {
  position: relative;
  width: 100%;
  height: 100%;
}

.AudiosByLanguage_heroImageContainer__qYz7K {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.AudiosByLanguage_heroImage__hpHHD {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.AudiosByLanguage_heroGradient__O2B5A {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to top, 
    #1a1a1a 0%, 
    rgba(26, 26, 26, 0.8) 20%, 
    rgba(26, 26, 26, 0.4) 40%, 
    rgba(26, 26, 26, 0.2) 60%, 
    rgba(26, 26, 26, 0) 80%
  ),
  linear-gradient(
    to right, 
    #1a1a1a 0%, 
    rgba(26, 26, 26, 0.8) 15%, 
    rgba(26, 26, 26, 0) 40%
  );
  z-index: 2;
}

.AudiosByLanguage_heroContent__PRVJX {
  position: absolute;
  bottom: 20%;
  left: 5%;
  width: 50%;
  z-index: 3;
  animation: AudiosByLanguage_fadeIn__sabaa 1s ease;
}

@keyframes AudiosByLanguage_fadeIn__sabaa {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}


.AudiosByLanguage_heroDescription__19C7t {
  color: #ccc;
  line-height: 1.6;
  margin-bottom: 2rem;
  font-size: 1.1rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  max-width: 90%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.AudiosByLanguage_heroButtons__gMhWT {
  display: flex;
  gap: 1rem;
}

.AudiosByLanguage_playNowButton__Wz9XT, .AudiosByLanguage_moreInfoButton__8pZx1 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.7rem 1.5rem;
  border-radius: 0.25rem;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.AudiosByLanguage_playNowButton__Wz9XT {
  background-color: #e50914;
  color: white;
  border: none;
  display: none;
}



.AudiosByLanguage_moreInfoButton__8pZx1 {
  background-color: rgba(109, 109, 110, 0.7);
  color: white;
  border: none;
}

.AudiosByLanguage_moreInfoButton__8pZx1:hover {
  background-color: rgba(109, 109, 110, 0.9);
}

.AudiosByLanguage_heroNavButtons__ZLxcF {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
  z-index: 4;
}

.AudiosByLanguage_navButton__ekk3b {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: 0.7;
}

.AudiosByLanguage_heroSection__vgGYM:hover .AudiosByLanguage_navButton__ekk3b {
  opacity: 1;
}

.AudiosByLanguage_navButton__ekk3b:hover {
  background-color: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

.AudiosByLanguage_heroPagination__p5T1g {
  position: absolute;
  bottom: 8%;
  left: 5%;
  z-index: 5;
  display: flex;
  gap: 0.5rem;
}

.AudiosByLanguage_paginationBullet__aqAZJ {
  width: 12px;
  height: 3px;
  background-color: rgba(255, 255, 255, 0.5);
  display: inline-block;
  border-radius: 0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.AudiosByLanguage_paginationBulletActive__3bEaV {
  width: 20px;
  background-color: #e50914;
}

/* Language Title */
.AudiosByLanguage_languageTitle__1q-Zi {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  max-width: 95%;
  margin: 0 auto;
}

/* Grid Section */
.AudiosByLanguage_gridSection__WsyvZ {
  max-width: 95%;
  margin: 0 auto;
  padding-top: 0.5rem;
}

.AudiosByLanguage_gridContainer__4RB43 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1rem;
}

.AudiosByLanguage_gridItem__mRI\\+w {
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  transition: transform 0.3s ease;
  position: relative;
}

.AudiosByLanguage_gridItem__mRI\\+w:hover {
  z-index: 2;
}

.AudiosByLanguage_gridImageContainer__N3OV5 {
  width: 100%;
  height: 100%;
  position: relative;
}

.AudiosByLanguage_gridItemImage__tUYU6 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.AudiosByLanguage_gridItemOverlay__CrazY {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.9) 0%,
    rgba(0, 0, 0, 0.7) 30%,
    rgba(0, 0, 0, 0) 60%
  );
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 1rem;
}

.AudiosByLanguage_gridItem__mRI\\+w:hover .AudiosByLanguage_gridItemOverlay__CrazY {
  opacity: 1;
}

.AudiosByLanguage_overlayContent__z4BMo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

.AudiosByLanguage_gridItemTitle__0VNRL {
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0;
  color: white;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.AudiosByLanguage_gridItemMeta__RRZiC {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  font-size: 0.8rem;
  color: #ccc;
}

.AudiosByLanguage_itemGenre__fbTZ- {
  display: inline-block;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 0.2rem 0.5rem;
  border-radius: 0.5rem;
  font-size: 0.7rem;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.AudiosByLanguage_itemDuration__k\\+Hvc {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.75rem;
}

.AudiosByLanguage_itemPlayButton__gXS7Z {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(229, 9, 20, 0.8);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 0.5rem;
  transition: all 0.2s ease;
}

.AudiosByLanguage_itemPlayButton__gXS7Z:hover {
  background-color: #e50914;
  transform: scale(1.1);
}

/* Pagination Controls */
.AudiosByLanguage_paginationControls__yCPpW {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: 2rem 0;
  padding-bottom: 2rem;
}

.AudiosByLanguage_paginationButton__fJSei {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.AudiosByLanguage_paginationButton__fJSei:hover:not(.AudiosByLanguage_disabled__D70Hz) {
  background-color: rgba(255, 255, 255, 0.2);
}

.AudiosByLanguage_disabled__D70Hz {
  opacity: 0.5;
  cursor: not-allowed;
}

.AudiosByLanguage_pageNumbers__FRDU5 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.AudiosByLanguage_pageNumber__zKPqP {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.AudiosByLanguage_pageNumber__zKPqP:hover:not(.AudiosByLanguage_activePage__kjI-2) {
  background-color: rgba(255, 255, 255, 0.2);
}

.AudiosByLanguage_activePage__kjI-2 {
  background-color: #e50914;
}

.AudiosByLanguage_ellipsis__upnR8 {
  color: white;
  font-weight: bold;
}

/* Loading & Error States */
.AudiosByLanguage_loaderContainer__ogxn9 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  background-color: #1a1a1a;
}

.AudiosByLanguage_errorContainer__0rpP- {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  color: #e53e3e;
  font-size: 1.2rem;
  background-color: #1a1a1a;
}

.AudiosByLanguage_noContent__eNUP9 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  color: #e5e5e5;
  font-size: 1.2rem;
}

/* Responsive Styles */
@media (max-width: 1280px) {
  .AudiosByLanguage_gridContainer__4RB43 {
    grid-template-columns: repeat(6, 1fr);
  }
  
  .AudiosByLanguage_heroAudioTitle__LCT0\\+ {
    font-size: 2.5rem;
  }
  
  .AudiosByLanguage_heroContent__PRVJX {
    width: 60%;
  }
}

@media (max-width: 1024px) {
  .AudiosByLanguage_gridContainer__4RB43 {
    grid-template-columns: repeat(5, 1fr);
  }
  
  .AudiosByLanguage_heroSection__vgGYM {
    height: 60vh;
  }
  
  .AudiosByLanguage_heroAudioTitle__LCT0\\+ {
    font-size: 2rem;
  }
  
  .AudiosByLanguage_heroContent__PRVJX {
    width: 70%;
    bottom: 15%;
  }
  
  .AudiosByLanguage_heroDescription__19C7t {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .AudiosByLanguage_gridContainer__4RB43 {
    grid-template-columns: repeat(4, 1fr);
  }
  
  .AudiosByLanguage_heroSection__vgGYM {
    height: 50vh;
  }
  
  .AudiosByLanguage_heroAudioTitle__LCT0\\+ {
    font-size: 1.8rem;
  }
  
  .AudiosByLanguage_heroContent__PRVJX {
    width: 80%;
    bottom: 10%;
  }
  
  .AudiosByLanguage_heroButtons__gMhWT {
    flex-direction: column;
    gap: 0.5rem;
    width: 60%;
  }
  
  .AudiosByLanguage_playNowButton__Wz9XT, .AudiosByLanguage_moreInfoButton__8pZx1 {
    font-size: 0.9rem;
    padding: 0.6rem 1rem;
  }
  
  .AudiosByLanguage_languageTitle__1q-Zi {
    font-size: 1.5rem;
  }
  
  .AudiosByLanguage_pageNumbers__FRDU5 {
    display: none;
  }
  
  .AudiosByLanguage_paginationControls__yCPpW {
    justify-content: space-between;
    padding: 0 1rem;
  }
}

@media (max-width: 640px) {
  .AudiosByLanguage_gridContainer__4RB43 {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .AudiosByLanguage_heroSection__vgGYM {
    height: 40vh;
  }
  
  .AudiosByLanguage_heroAudioTitle__LCT0\\+ {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
  
  .AudiosByLanguage_heroMeta__89NsP {
    gap: 0.5rem;
    margin-bottom: 1rem;
    font-size: 0.8rem;
  }
  
  .AudiosByLanguage_heroContent__PRVJX {
    width: 90%;
    bottom: 10%;
  }
  
  .AudiosByLanguage_heroDescription__19C7t {
    font-size: 0.9rem;
    -webkit-line-clamp: 2;
    margin-bottom: 1rem;
  }
  
  .AudiosByLanguage_heroButtons__gMhWT {
    width: 100%;
  }
  
  .AudiosByLanguage_playNowButton__Wz9XT {
    font-size: 0.8rem;
    padding: 0.5rem 1rem;
  }
  
  .AudiosByLanguage_languageTitle__1q-Zi {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .AudiosByLanguage_gridContainer__4RB43 {
    grid-template-columns: repeat(3, 1fr);
    gap: 0.5rem;
  }
  
  .AudiosByLanguage_heroAudioTitle__LCT0\\+ {
    font-size: 1.3rem;
  }
  
  .AudiosByLanguage_heroDescription__19C7t {
    display: none;
  }
  
  .AudiosByLanguage_heroMeta__89NsP {
    margin-bottom: 1rem;
  }
  
  .AudiosByLanguage_itemGenre__fbTZ- {
    font-size: 0.6rem;
  }
  
  .AudiosByLanguage_itemPlayButton__gXS7Z {
    width: 32px;
    height: 32px;
  }
  
  .AudiosByLanguage_gridItemTitle__0VNRL {
    font-size: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Audio/Component/CSS/AudiosByLanguage.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;;AAEnB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;;;;;;;;;GAaC;EACD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,UAAU;EACV,iDAAyB;AAC3B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;;AAGA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;;;AAIA;EACE,0CAA0C;EAC1C,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  padding-bottom: 2rem;\n  background-color: #1a1a1a;\n  color: #fff;\n  min-height: 100vh;\n  \n}\n\n/* Hero Section Styles - Netflix-like */\n.heroSection {\n  position: relative;\n  margin-bottom: 0rem;\n  height: 80vh;\n  max-height: 700px;\n  width: 100%;\n}\n\n.heroSwiper {\n  width: 100%;\n  height: 100%;\n}\n\n.heroSlide {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.heroImageContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.heroImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.heroGradient {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    to top, \n    #1a1a1a 0%, \n    rgba(26, 26, 26, 0.8) 20%, \n    rgba(26, 26, 26, 0.4) 40%, \n    rgba(26, 26, 26, 0.2) 60%, \n    rgba(26, 26, 26, 0) 80%\n  ),\n  linear-gradient(\n    to right, \n    #1a1a1a 0%, \n    rgba(26, 26, 26, 0.8) 15%, \n    rgba(26, 26, 26, 0) 40%\n  );\n  z-index: 2;\n}\n\n.heroContent {\n  position: absolute;\n  bottom: 20%;\n  left: 5%;\n  width: 50%;\n  z-index: 3;\n  animation: fadeIn 1s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n\n.heroDescription {\n  color: #ccc;\n  line-height: 1.6;\n  margin-bottom: 2rem;\n  font-size: 1.1rem;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n  max-width: 90%;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.heroButtons {\n  display: flex;\n  gap: 1rem;\n}\n\n.playNowButton, .moreInfoButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.7rem 1.5rem;\n  border-radius: 0.25rem;\n  font-weight: 600;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.playNowButton {\n  background-color: #e50914;\n  color: white;\n  border: none;\n  display: none;\n}\n\n\n\n.moreInfoButton {\n  background-color: rgba(109, 109, 110, 0.7);\n  color: white;\n  border: none;\n}\n\n.moreInfoButton:hover {\n  background-color: rgba(109, 109, 110, 0.9);\n}\n\n.heroNavButtons {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  transform: translateY(-50%);\n  display: flex;\n  justify-content: space-between;\n  padding: 0 1rem;\n  z-index: 4;\n}\n\n.navButton {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.5);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  opacity: 0.7;\n}\n\n.heroSection:hover .navButton {\n  opacity: 1;\n}\n\n.navButton:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n  transform: scale(1.1);\n}\n\n.heroPagination {\n  position: absolute;\n  bottom: 8%;\n  left: 5%;\n  z-index: 5;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.paginationBullet {\n  width: 12px;\n  height: 3px;\n  background-color: rgba(255, 255, 255, 0.5);\n  display: inline-block;\n  border-radius: 0;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.paginationBulletActive {\n  width: 20px;\n  background-color: #e50914;\n}\n\n/* Language Title */\n.languageTitle {\n  font-size: 20px;\n  font-weight: 700;\n  color: #fff;\n  max-width: 95%;\n  margin: 0 auto;\n}\n\n/* Grid Section */\n.gridSection {\n  max-width: 95%;\n  margin: 0 auto;\n  padding-top: 0.5rem;\n}\n\n.gridContainer {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 1rem;\n}\n\n.gridItem {\n  cursor: pointer;\n  border-radius: 4px;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  position: relative;\n}\n\n.gridItem:hover {\n  z-index: 2;\n}\n\n.gridImageContainer {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.gridItemImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.gridItemOverlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.9) 0%,\n    rgba(0, 0, 0, 0.7) 30%,\n    rgba(0, 0, 0, 0) 60%\n  );\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 1rem;\n}\n\n.gridItem:hover .gridItemOverlay {\n  opacity: 1;\n}\n\n.overlayContent {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.gridItemTitle {\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0;\n  color: white;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.gridItemMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  font-size: 0.8rem;\n  color: #ccc;\n}\n\n.itemGenre {\n  display: inline-block;\n  background-color: rgba(255, 255, 255, 0.2);\n  padding: 0.2rem 0.5rem;\n  border-radius: 0.5rem;\n  font-size: 0.7rem;\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.itemDuration {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.75rem;\n}\n\n.itemPlayButton {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: rgba(229, 9, 20, 0.8);\n  border: none;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-bottom: 0.5rem;\n  transition: all 0.2s ease;\n}\n\n.itemPlayButton:hover {\n  background-color: #e50914;\n  transform: scale(1.1);\n}\n\n/* Pagination Controls */\n.paginationControls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin: 2rem 0;\n  padding-bottom: 2rem;\n}\n\n.paginationButton {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background-color: rgba(255, 255, 255, 0.1);\n  border: none;\n  border-radius: 4px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.paginationButton:hover:not(.disabled) {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pageNumbers {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pageNumber {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: white;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.pageNumber:hover:not(.activePage) {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.activePage {\n  background-color: #e50914;\n}\n\n.ellipsis {\n  color: white;\n  font-weight: bold;\n}\n\n/* Loading & Error States */\n.loaderContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 70vh;\n  background-color: #1a1a1a;\n}\n\n.errorContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 70vh;\n  color: #e53e3e;\n  font-size: 1.2rem;\n  background-color: #1a1a1a;\n}\n\n.noContent {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 70vh;\n  color: #e5e5e5;\n  font-size: 1.2rem;\n}\n\n/* Responsive Styles */\n@media (max-width: 1280px) {\n  .gridContainer {\n    grid-template-columns: repeat(6, 1fr);\n  }\n  \n  .heroAudioTitle {\n    font-size: 2.5rem;\n  }\n  \n  .heroContent {\n    width: 60%;\n  }\n}\n\n@media (max-width: 1024px) {\n  .gridContainer {\n    grid-template-columns: repeat(5, 1fr);\n  }\n  \n  .heroSection {\n    height: 60vh;\n  }\n  \n  .heroAudioTitle {\n    font-size: 2rem;\n  }\n  \n  .heroContent {\n    width: 70%;\n    bottom: 15%;\n  }\n  \n  .heroDescription {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .gridContainer {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  \n  .heroSection {\n    height: 50vh;\n  }\n  \n  .heroAudioTitle {\n    font-size: 1.8rem;\n  }\n  \n  .heroContent {\n    width: 80%;\n    bottom: 10%;\n  }\n  \n  .heroButtons {\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 60%;\n  }\n  \n  .playNowButton, .moreInfoButton {\n    font-size: 0.9rem;\n    padding: 0.6rem 1rem;\n  }\n  \n  .languageTitle {\n    font-size: 1.5rem;\n  }\n  \n  .pageNumbers {\n    display: none;\n  }\n  \n  .paginationControls {\n    justify-content: space-between;\n    padding: 0 1rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .gridContainer {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .heroSection {\n    height: 40vh;\n  }\n  \n  .heroAudioTitle {\n    font-size: 1.5rem;\n    margin-bottom: 0.5rem;\n  }\n  \n  .heroMeta {\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n    font-size: 0.8rem;\n  }\n  \n  .heroContent {\n    width: 90%;\n    bottom: 10%;\n  }\n  \n  .heroDescription {\n    font-size: 0.9rem;\n    -webkit-line-clamp: 2;\n    margin-bottom: 1rem;\n  }\n  \n  .heroButtons {\n    width: 100%;\n  }\n  \n  .playNowButton {\n    font-size: 0.8rem;\n    padding: 0.5rem 1rem;\n  }\n  \n  .languageTitle {\n    font-size: 1.2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .gridContainer {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0.5rem;\n  }\n  \n  .heroAudioTitle {\n    font-size: 1.3rem;\n  }\n  \n  .heroDescription {\n    display: none;\n  }\n  \n  .heroMeta {\n    margin-bottom: 1rem;\n  }\n  \n  .itemGenre {\n    font-size: 0.6rem;\n  }\n  \n  .itemPlayButton {\n    width: 32px;\n    height: 32px;\n  }\n  \n  .gridItemTitle {\n    font-size: 0.8rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AudiosByLanguage_container__rz1HC`,
	"heroSection": `AudiosByLanguage_heroSection__vgGYM`,
	"heroSwiper": `AudiosByLanguage_heroSwiper__Mblo+`,
	"heroSlide": `AudiosByLanguage_heroSlide__W5hxe`,
	"heroImageContainer": `AudiosByLanguage_heroImageContainer__qYz7K`,
	"heroImage": `AudiosByLanguage_heroImage__hpHHD`,
	"heroGradient": `AudiosByLanguage_heroGradient__O2B5A`,
	"heroContent": `AudiosByLanguage_heroContent__PRVJX`,
	"fadeIn": `AudiosByLanguage_fadeIn__sabaa`,
	"heroDescription": `AudiosByLanguage_heroDescription__19C7t`,
	"heroButtons": `AudiosByLanguage_heroButtons__gMhWT`,
	"playNowButton": `AudiosByLanguage_playNowButton__Wz9XT`,
	"moreInfoButton": `AudiosByLanguage_moreInfoButton__8pZx1`,
	"heroNavButtons": `AudiosByLanguage_heroNavButtons__ZLxcF`,
	"navButton": `AudiosByLanguage_navButton__ekk3b`,
	"heroPagination": `AudiosByLanguage_heroPagination__p5T1g`,
	"paginationBullet": `AudiosByLanguage_paginationBullet__aqAZJ`,
	"paginationBulletActive": `AudiosByLanguage_paginationBulletActive__3bEaV`,
	"languageTitle": `AudiosByLanguage_languageTitle__1q-Zi`,
	"gridSection": `AudiosByLanguage_gridSection__WsyvZ`,
	"gridContainer": `AudiosByLanguage_gridContainer__4RB43`,
	"gridItem": `AudiosByLanguage_gridItem__mRI+w`,
	"gridImageContainer": `AudiosByLanguage_gridImageContainer__N3OV5`,
	"gridItemImage": `AudiosByLanguage_gridItemImage__tUYU6`,
	"gridItemOverlay": `AudiosByLanguage_gridItemOverlay__CrazY`,
	"overlayContent": `AudiosByLanguage_overlayContent__z4BMo`,
	"gridItemTitle": `AudiosByLanguage_gridItemTitle__0VNRL`,
	"gridItemMeta": `AudiosByLanguage_gridItemMeta__RRZiC`,
	"itemGenre": `AudiosByLanguage_itemGenre__fbTZ-`,
	"itemDuration": `AudiosByLanguage_itemDuration__k+Hvc`,
	"itemPlayButton": `AudiosByLanguage_itemPlayButton__gXS7Z`,
	"paginationControls": `AudiosByLanguage_paginationControls__yCPpW`,
	"paginationButton": `AudiosByLanguage_paginationButton__fJSei`,
	"disabled": `AudiosByLanguage_disabled__D70Hz`,
	"pageNumbers": `AudiosByLanguage_pageNumbers__FRDU5`,
	"pageNumber": `AudiosByLanguage_pageNumber__zKPqP`,
	"activePage": `AudiosByLanguage_activePage__kjI-2`,
	"ellipsis": `AudiosByLanguage_ellipsis__upnR8`,
	"loaderContainer": `AudiosByLanguage_loaderContainer__ogxn9`,
	"errorContainer": `AudiosByLanguage_errorContainer__0rpP-`,
	"noContent": `AudiosByLanguage_noContent__eNUP9`,
	"heroAudioTitle": `AudiosByLanguage_heroAudioTitle__LCT0+`,
	"heroMeta": `AudiosByLanguage_heroMeta__89NsP`
};
export default ___CSS_LOADER_EXPORT___;
